import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onNewPage, onImport, onExport, onSettings }) => {
  return (
    <div className="flex flex-wrap items-center gap-2 md:gap-3">
      <Button
        variant="default"
        iconName="Plus"
        iconPosition="left"
        onClick={onNewPage}
      >
        <span className="hidden sm:inline">New Page</span>
        <span className="sm:hidden">New</span>
      </Button>

      <Button
        variant="outline"
        iconName="Upload"
        iconPosition="left"
        onClick={onImport}
      >
        <span className="hidden md:inline">Import</span>
      </Button>

      <Button
        variant="outline"
        iconName="Download"
        iconPosition="left"
        onClick={onExport}
      >
        <span className="hidden md:inline">Export</span>
      </Button>

      <Button
        variant="ghost"
        iconName="Settings"
        size="icon"
        onClick={onSettings}
      />
    </div>
  );
};

export default QuickActions;